import { IntlShape } from "gatsby-plugin-react-intl"

export default ({ intl, monthAbbreviation }: { intl: IntlShape, monthAbbreviation: string }) => {
    let name = intl.formatMessage({ id: `common.months.${monthAbbreviation}` });
    if (monthAbbreviation != 'all') {
        return intl.formatMessage({ id: `common.in` })+' '+name;
    }
    return name.slice(0, 1).toLowerCase + name.slice(1);
}